<!--
 * @Author: p_fy
 * @Date: 2019-06-18 08:14:49
 * @LastEditors: pfy
 * @LastEditTime: 2019-09-24 10:20:05
 * @Description: 资质认证页面，提交企业资质认证信息。
 -->
<template>
  <div>
    <div class="main-wrap">
      <div class="menu-head title">
        <div>
          <span @click="apilist">{{ setCompanyShow() }}资质认证</span>
        </div>
      </div>
      <div v-if="tjCard" class="tjClas">
        <el-card class="box-card">
          <span>您的认证资料已提交</span>
          <span><a href="JavaScript:void(0);" class="sfSty" @click="renzhengCrad(true,false,false,false, false)">点击查看详情</a></span>
        </el-card>
      </div>

      <div v-if="SuccessCard" class="SuccessClas">
        <el-card class="box-card">
          <span>您已成功认证!</span>
          <span>新兴物流平台欢迎您</span>
          <!-- <span style="width:100%;font-size: -webkit-xxx-large;font-family: cursive;margin-top:1rem;">{{ authentication.companyName }}欢迎您</span> -->
          <el-row :gutter="20" class="suCentClas">
            <el-col :span="8">
              <span><a href="JavaScript:void(0);" class="sfSty" @click="renzhengCrad(true,false,false,false, false)">点击查看详情</a></span>
            </el-col>
            <el-col :span="8">
              <span><a href="JavaScript:void(0);" class="sfSty" @click="renzhengCrad(true,true,false,false, false)">变更认证资料</a></span>
            </el-col>
            <el-col :span="8">
              <span><a href="JavaScript:void(0);" class="sfSty" @click="OpenStaff">进入管理中心</a></span>
            </el-col>
          </el-row>
        </el-card>
      </div>

      <div v-if="failCard" class="failClas">
        <el-card class="box-card">
          <span>您没有通过审核!</span>
          <!-- <span style="width:100%;font-size: -webkit-xxx-large;font-family: cursive;">您填写的资料存在以下问题</span> -->
          <span>
            <ul>
              <li v-for="(item,index) in authentication.returnReasons" :key="index">{{ failShow(item,index) }}</li>
            </ul>
            <br>
            <span>备注：{{ authentication.remarks }}</span>
          </span>
          <span><a href="JavaScript:void(0);" class="sfSty" @click="renzhengCrad(true,true,false,false, false)">去修改</a></span>
        </el-card>
      </div>

      <div v-if="renzhenCard" v-loading="loading">
        <div>
          <el-form
            ref="rulesForm"
            :rules="rules"
            :disabled="!submitCard"
            :model="authentication"
            :label-position="'right'"
            label-width="145px"
            style="padding-left: 0rem;padding-right: 2rem;"
          >
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="认证类型">
                  <span style="color: #be2316;">{{ setCompanyShow() }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-row>
                  <el-col :span="13">
                    <el-form-item label="公司logo" prop="companyLogo" class="companyLogoItem">
                      <g-upload :limit="1" :max-size="1" :method-name="authenticationFile" is-edit class="companyLogo" multiple :img-list.sync="authentication.companyLogo" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="11" class="logText">
                    上传格式.jpg/.png文件，建议尺寸1920*700，且大小不超过1M
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="12">
                <el-form-item label="账号" style="margin-bottom: 0px;margin-top: 7px;">
                  <span>{{ userInfo.userName }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="公司名称" prop="companyName">
                  <el-input v-model.trim="authentication.companyName" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="统一社会信用代码" prop="taxpayerNumber">
                  <el-col v-if="(companyShow ) && submitCard && (authentication.authStatus !=null && authentication.authStatus != '2')" :span="21" style="padding-left: 0px;padding-right: 0px;">
                    <el-input v-model.trim="authentication.taxpayerNumber" :disabled="!(authentication.authStatus !=null && authentication.authStatus != '2' && authentication.authStatus != '5')" />
                  </el-col>
                  <el-input v-else v-model.trim="authentication.taxpayerNumber" :disabled="!(authentication.authStatus !=null && authentication.authStatus != '2' && authentication.authStatus != '5')" />
                  <el-col v-if="(companyShow ) && submitCard && (authentication.authStatus !=null && authentication.authStatus != '2')" class="line" :span="3" style="text-align: center;font-size: smaller;padding-left:0px;padding-right: 0px;"><a href="JavaScript:void(0);" class="sfSty" @click="appealAchieve">申诉</a></el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="联系人" prop="companyContact">
                  <el-input v-model.trim="authentication.companyContact" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系电话" prop="contactTel">
                  <el-input v-model.trim="authentication.contactTel" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="公司固话" prop="companyTel">
                  <el-input v-model.trim="authentication.companyTel" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="银行账户" prop="bankAccount">
                  <el-input v-model.trim="authentication.bankAccount" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="开户行" prop="openingBank">
                  <el-input v-model.trim="authentication.openingBank" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="营业年限" prop="businessYears">
                  <el-select v-model="authentication.businessYears" placeholder="" class="checkboxSty">
                    <el-option v-for="city in authenType.businessDuration" :key="city.label" :label="city.label" :value="city.value" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 运力方--开始 -->
            <div v-if="userType == '2'">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="运输范围" prop="transportRange">
                    <el-select v-model="authentication.transportRange" placeholder="" class="checkboxSty">
                      <el-option v-for="city in authenType.transportRange" :key="city.label" :label="city.label" :value="city.value" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="运输方式" prop="transportMode">
                    <el-checkbox-group v-model="authentication.transportMode">
                      <el-checkbox v-for="city in authenType.transportType" :key="city.label" :label="city.value">{{ city.label }}</el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="自有车辆" prop="ownedVehicle">
                    <el-select v-model="authentication.ownedVehicle" placeholder="" class="checkboxSty">
                      <el-option v-for="city in authenType.ownedVehicle" :key="city.label" :label="city.label" :value="city.value" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="信息化情况" prop="informatization">
                    <el-select v-model="authentication.informatization" placeholder="" class="checkboxSty">
                      <el-option v-for="city in authenType.informatization" :key="city.label" :label="city.label" :value="city.value" />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <!-- 运力方--结束 -->
            <!-- 仓储方--开始 -->
            <div v-if="userType == '3'">
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="仓库类型" prop="warehouseType">
                    <el-checkbox-group v-model="authentication.warehouseType" @change="typeSel">
                      <el-checkbox v-for="city in authenType.authenticationType" :key="city.label" :label="city.value">{{ city.label }}</el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="可储存类型" prop="storageType">
                    <el-checkbox-group v-if="authentication.warehouseType == '1'" v-model="authentication.storageType">
                      <el-checkbox v-for="city in authenType.storageType" :key="city.label" :label="city.value">{{ city.label }}</el-checkbox>
                    </el-checkbox-group>
                    <el-checkbox-group v-if="authentication.warehouseType == '2'" v-model="authentication.storageType">
                      <el-checkbox v-for="city in authenType.tankType" :key="city.label" :label="city.value">{{ city.label }}</el-checkbox>
                    </el-checkbox-group>
                    <el-checkbox-group v-if="authentication.warehouseType == '1,2' || authentication.warehouseType == '2,1'" v-model="authentication.storageType">
                      <el-checkbox v-for="city in authenType.attestationStorageType" :key="city.label" :label="city.value">{{ city.label }}</el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="罐区容积" prop="casingVolume">
                    <el-input v-model.trim="authentication.casingVolume" :disabled="kqrjDisabled">
                      <template slot="append">m³</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="储罐数量" prop="tanksCount">
                    <el-input v-model.trim="authentication.tanksCount" :disabled="cgslDisabled" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="自有仓库面积" prop="owendStorageArea">
                    <el-select v-model.trim="authentication.owendStorageArea" placeholder="" class="checkboxSty" :disabled="zyDisabled">
                      <el-option v-for="city in authenType.owendStorageArea" :key="city.label" :label="city.label" :value="city.value" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="信息化情况" prop="informatization">
                    <el-select v-model.trim="authentication.informatization" placeholder="" class="checkboxSty">
                      <el-option v-for="city in authenType.informatization" :key="city.label" :label="city.label" :value="city.value" />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <!-- 仓储方--结束 -->
            <div v-if="userType == '2' || userType == '3'">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="电子运单管理" prop="electronicWaybillManagement">
                    <el-select v-model.trim="authentication.electronicWaybillManagement" placeholder="" class="checkboxSty">
                      <el-option v-for="city in authenType.electronicWaybillManagement" :key="city.label" :label="city.label" :value="city.value" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="客户查询系统" prop="customerInquirySystem">
                    <el-select v-model.trim="authentication.customerInquirySystem" placeholder="" class="checkboxSty">
                      <el-option v-for="city in authenType.CustomerEnquirySystem" :key="city.label" :label="city.label" :value="city.value" />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="公司地址" prop="companyAddress">
                  <el-cascader
                    v-model="authentication.companyAddress"
                    :options="area"
                    :filterable="true"
                    :props="{ expandTrigger: 'hover' ,
                              checkStrictly: true}"
                    style="width: 100%;"
                    class="companyAddress"
                    @expand-change="expandChange"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="详细地址" class="detailsAddress" prop="detailsAddress">
                  <el-autocomplete
                    v-model="authentication.detailsAddress"
                    popper-class="my-autocomplete"
                    :fetch-suggestions="querySearch"
                    placeholder="请输入内容"
                    style="width: 100%;"
                    @select="handleSelect"
                  >
                    <template slot-scope="{ item }">
                      <div class="name">{{ item.value }}</div>
                      <!--<span class="addr">{{ item.address }}</span>-->
                    </template>
                  </el-autocomplete>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="主营业务" prop="mainBusiness">
                  <el-input v-model="authentication.mainBusiness" type="textarea" :rows="6" />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="营业执照" prop="licenseUrl">
                  <g-upload :max-size="10" :limit="1" :method-name="authenticationFile" is-edit multiple :img-list.sync="authentication.licenseUrl" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <span v-if="submitCard" class="el-form-item__label" style="line-height: 30px;text-align: left;">上传有效营业执照,照片须为清晰、完整电子版图片,无遮挡、涂抹.支持不超过10M的jpg、bmp图片,可为扫描件或数码照</span>
                <div v-if="submitCard" class="el-form-item">
                  <span class="el-form-item__label">如图所示：</span>
                  <img src="../../../../assets/img/geren/yingye.png" style="width:45%;">
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="银行开户许可证" prop="permitUrl">
                  <g-upload :max-size="10" :limit="1" is-edit :method-name="authenticationFile" multiple :img-list.sync="authentication.permitUrl" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <span v-if="submitCard" class="el-form-item__label" style="line-height: 30px;text-align: left;">上传有效银行开户许可证,照片须为清晰、完整电子版图片,无遮挡、涂抹.支持不超过10M的jpg、bmp图片,可为扫描件或数码照</span>
                <div v-if="submitCard" class="el-form-item">
                  <span class="el-form-item__label">如图所示：</span>
                  <img src="../../../../assets/img/geren/kaihuhang.jpg" style="width:45%;">
                </div>
              </el-col>
            </el-row>

            <div v-if="userType == '2'">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="车辆运营证" prop="vehicleOperationUrl">
                    <g-upload :max-size="1" is-edit :limit="1" :method-name="authenticationFile" multiple :img-list.sync="authentication.vehicleOperationUrl" />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <span v-if="submitCard" class="el-form-item__label" style="line-height: 30px;text-align: left;">上传有效车辆运营证,照片须为清晰、完整电子版图片,无遮挡、涂抹.支持55k-1M的jpg、bmp图片,可为扫描件或数码照</span>
                  <div v-if="submitCard" class="el-form-item">
                    <span class="el-form-item__label">如图所示：</span>
                    <img src="../../../../assets/img/geren/weixian.png" style="width:45%;">
                  </div>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="道路运输许可证" prop="roadTransportUrl">
                    <g-upload :max-size="1" is-edit :limit="1" :method-name="authenticationFile" multiple :img-list.sync="authentication.roadTransportUrl" />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <span v-if="submitCard" class="el-form-item__label" style="line-height: 30px;text-align: left;">上传有效道路运输许可证,照片须为清晰、完整电子版图片,无遮挡、涂抹.支持55k-1M的jpg、bmp图片,可为扫描件或数码照</span>
                  <div v-if="submitCard" class="el-form-item">
                    <span class="el-form-item__label">如图所示：</span>
                    <img src="../../../../assets/img/geren/daoruyunshu.png" style="width:45%;">
                  </div>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="安全运输许可证" prop="safeTransportUrl">
                    <g-upload :max-size="1" is-edit :limit="1" :method-name="authenticationFile" multiple :img-list.sync="authentication.safeTransportUrl" />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <span v-if="submitCard" class="el-form-item__label" style="line-height: 30px;text-align: left;">上传有效安全运输许可证,照片须为清晰、完整电子版图片,无遮挡、涂抹.支持55k-1M的jpg、bmp图片,可为扫描件或数码照</span>
                  <div v-if="submitCard" class="el-form-item">
                    <span class="el-form-item__label">如图所示：</span>
                    <img src="../../../../assets/img/geren/weixian.png" style="width:45%">
                  </div>
                </el-col>
              </el-row>
            </div>

            <el-row v-if="submitCard" :gutter="20">
              <el-col :span="12">
                <el-form-item label="">
                  <span style="color: #be2316;">注：</span>
                  <span>*均为必填项</span>
                </el-form-item>
              </el-col>
            </el-row>
            <div v-if="submitCard">
              <el-button
                class="el-button-ml"
                type="danger"
                round
                :disabled="post_flag"
                @click="modifiedAuthentication('rulesForm')"
              >提交</el-button>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div></template>
<script type="text/ecmascript-6">
import AMap from 'AMap' // 引入高德地图
import store from '@/store'
import { mapGetters } from 'vuex'
// 引用数据
import { createInfo, getUserInfo, editInfo, getByTaxpayerNumber, Tyshyxdm, getDict, getArea, luhmFetchCheck } from '@/api/personal/user/qualifications-authen/authentication'
import { tableClass } from '@/api/personal/user/qualifications-authen/AuthenticationParam' // 仓储方表格、表单参数列表
const param = tableClass.getData() // 引用表格参数类(包含查询条件的表单)
import { DatabaseUtil } from '@/utils/databaseUtils'
const dataBase = new DatabaseUtil()
export default {
  name: 'QualificationsAuthen',
  components: { },
  inject: ['reload'],
  data() {
    // 统一社会信用代码校验方法
    var taxpayerNumberRules = (rule, value, callback) => {
      if (this.authentication.authStatus == '5') {
        this.companyShow = false
        callback()
        return
      }
      if (!value) {
        this.companyShow = false
        return callback(new Error('请输入统一社会信用代码'))
      } else {
        var v = new Tyshyxdm().verify(value)
        if (!v) {
          return callback(new Error('不是有效的统一社会信用编码！'))
        }
      }
      // if (value == this.authentication.taxpayerNumber) {
      //   callback()
      // }
      getByTaxpayerNumber({ taxpayerNumber: this.authentication.taxpayerNumber, userId: this.authentication.userId,id:this.authentication.id }).then((res) => {
        // console.log(value == this.authentication.taxpayerNumber)

        if (res.result != null && res.result > 0) {
          console.log(this.authentication);
          // console.log(12312321313312)
          this.companyShow = true
          return callback(new Error('该公司已存在!'))
        } else {
          this.companyShow = false
          callback()
        }
      }).catch(() => {
        this.companyShow = false
        return callback(new Error('异常!'))
      })
    }
    // 公司logo校验方法
    var companyLogoRules = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请上传公司logo'))
      } else {
        callback()
      }
    }
    // 营业执照校验方法
    var licenseRules = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请上传营业执照'))
      } else {
        callback()
      }
    }
    // 银行开户许可证校验方法
    var permitValidator = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请上传银行开户许可证'))
      } else {
        callback()
      }
    }
    // 车辆营运证校验方法
    var vehicleOperationRules = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请上传车辆运营证'))
      } else {
        callback()
      }
    }
    // 道路运输许可证校验方法
    var roadTransportRules = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请上传道路运输许可证'))
      } else {
        callback()
      }
    }
    // 安全运输许可证校验方法
    var safeTransportRules = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请上传安全运输许可证'))
      } else {
        callback()
      }
    }
    // 罐区容积证校验方法
    var reg = /^(\+|-)?[0-9]{1,7}(\.\d{1,2})?$/
    var casingVolume = (rule, value, callback) => {
      if (this.authentication.warehouseType.length < 1 && this.authentication.warehouseType.length > 0) {
        if (this.authentication.warehouseType[0] == 2) {
          if (!value) {
            return callback(new Error('请输入罐区容积'))
          } else {
            if (value != 0 && reg.test(value)) {
              callback()
            } else {
              return callback(new Error('请输入最多7位数字,且小数点最多两位'))
            }
          }
        }
      } else if (this.authentication.warehouseType.length > 1) {
        if (!value) {
          return callback(new Error('请输入罐区容积'))
        } else {
          if (value != 0 && reg.test(value)) {
            callback()
          } else {
            return callback(new Error('请输入最多7位数字,且小数点最多两位'))
          }
        }
      } else {
        callback()
      }
    }
    // 储罐数量校验方法
    var tanksCountReg = /^[1-9]{1,7}$/
    var tanksCount = (rule, value, callback) => {
      if (this.authentication.warehouseType.length < 1 && this.authentication.warehouseType.length > 0) {
        if (this.authentication.warehouseType[0] == 2) {
          if (!value) {
            return callback(new Error('请输入储罐数量'))
          } else {
            if (tanksCountReg.test(value)) {
              callback()
            } else {
              return callback(new Error('请输入正整数(最多7位)'))
            }
          }
        }
      } else if (this.authentication.warehouseType.length > 1) {
        if (!value) {
          return callback(new Error('请输入储罐数量'))
        } else {
          if (tanksCountReg.test(value)) {
            callback()
          } else {
            return callback(new Error('请输入正整数(最多7位)'))
          }
        }
      } else {
        callback()
      }
    }
    // 自有仓库面积校验方法
    var owendStorageArea = (rule, value, callback) => {
      if (this.authentication.warehouseType.length < 1 && this.authentication.warehouseType.length > 0) {
        if (this.authentication.warehouseType[0] == 1) {
          if (!value) {
            return callback(new Error('请至少选择一个自有仓库'))
          } else {
            callback()
          }
        }
      } else if (this.authentication.warehouseType.length > 1) {
        if (!value) {
          return callback(new Error('请至少选择一个自有仓库'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    // 银行账号校验方法
    var bankAccount = (rule, value, callback) => {
      if (value == '') {
        return callback(new Error('请填写银行账号'))
      } else {
        luhmFetchCheck(value).then(bankResult => {
          this.authentication.openingBank = bankResult
          callback()
        }).catch(err => {
          console.log(err)
          return callback(new Error('卡号输入有误！请重新填写!'))
        })
      }
    }
    return {
      ...JSON.parse(JSON.stringify(param)), // 定义属性元素引用
      authenticationFile: '',
      loading: true, // 预加载样式
      area: null, // 地址字典
      authenType: {
        businessDuration: [], // 营业年限
        companyName: null,
        transportRange: [], // 运输范围
        transportType: [], // 运输方式
        ownedVehicle: [], // 自有车辆
        informatization: [], // 信息化情况
        authenticationType: [], // 资质认证仓库类型
        attestationStorageType: [], // 可存储类型
        storageType: [], // 仓库储存类型
        tankType: [], // 罐区储存类型
        owendStorageArea: [], // 自有仓面积
        electronicWaybillManagement: [], // 电子运单管理
        CustomerEnquirySystem: [] // 客户查询系统
      },
      rules: {
        companyName: [
          { required: true, message: '请输入公司名称' },
          { validator: this.$validate('company') }
        ],
        companyAddress: [{ required: true, message: '请选择公司地址', trigger: 'change' }], // 库房位置
        detailsAddress: [{ required: true, validator: this.$character(0, 200, 'check'), trigger: 'blur' }], // 详细位置
        // companyAddress: [{ required: true, message: '请输入公司地址', trigger: 'blur' }],
        companyContact: [
          { required: true, message: '请输入联系人' },
          { validator: this.$validate('names') }
        ],
        // contactTel: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
        contactTel: [
          { required: true, message: '请输入联系电话' },
          { required: true, validator: this.$validate('phone') }
        ],
        taxpayerNumber: [{ required: true, validator: taxpayerNumberRules, trigger: 'blur' }],
        bankAccount: [{ required: true, validator: bankAccount, trigger: 'blur' }],
        openingBank: [{ required: true, validator: this.$character(2, 20, 'check'), trigger: 'blur' }],
        transportMode: [{ type: 'array', required: true, message: '请至少选择一个运输方式', trigger: 'change' }],
        transportRange: [{ required: true, message: '请选择运输范围', trigger: 'change' }],
        warehouseType: [{ type: 'array', required: true, message: '请至少选择一个仓库类型', trigger: 'change' }],
        casingVolume: [{ required: true, validator: casingVolume }],
        tanksCount: [
          // { required: true, validator: tanksCount },
          { pattern: /^[1-9]\d{0,6}$/, message: '请输入正整数(最多7位)' }
        ],
        // tanksCount: [{ required: true, validator: tanksCount }],
        storageType: [{ type: 'array', required: true, message: '请至少选择一个可存储类型', trigger: 'change' }],
        owendStorageArea: [{ required: true, validator: owendStorageArea, trigger: 'change' }],
        ownedVehicle: [{ required: true, message: '请选择自有车辆', trigger: 'change' }],
        businessYears: [{ required: true, message: '请选择营业年限', trigger: 'change' }],
        informatization: [{ required: true, message: '请选择信息化情况', trigger: 'change' }],
        electronicWaybillManagement: [{ required: true, message: '请选择电子运单管理', trigger: 'change' }],
        customerInquirySystem: [{ required: true, message: '请选择客户查询系统', trigger: 'change' }],
        // companyTel: [{ required: true, message: '请输入公司固话', trigger: 'blur' }],
        companyTel: [
          { required: true, message: '请输入固话' },
          { required: true, validator: this.$validate('fixedLine') }
        ],
        mainBusiness: [
          { required: true, message: '请输入主营业务' },
          { max: 255, message: '最多可输入255个字符' }
          // { required: true, validator: mainBusiness, trigger: 'blur' }
        ],
        companyLogo: [{ required: true, validator: companyLogoRules, trigger: 'blur' }], // 公司logo
        licenseUrl: [{ required: true, validator: licenseRules, trigger: 'blur' }], // 营业执照（修改需审核）
        permitUrl: [{ required: true, validator: permitValidator, trigger: 'blur' }], // 银行开户许可证
        vehicleOperationUrl: [{ required: true, validator: vehicleOperationRules, trigger: 'blur' }], // 车辆营运证
        roadTransportUrl: [{ required: true, validator: roadTransportRules, trigger: 'blur' }], // 道路运输许可证
        safeTransportUrl: [{ required: true, validator: safeTransportRules, trigger: 'blur' }] // 安全运输许可证
      }
    }
  },
  computed: {
    ...mapGetters(['roles', 'userType', 'name', 'userInfo']),
    companyLogoArr() { // 企业Log图片回调
      return this.authentication.companyLogo.split(',').filter(n => n) // 数组去空
    },
    licenseUrlArr() { // 营业执照图片回调
      return this.authentication.licenseUrl.split(',').filter(n => n) // 数组去空
    },
    permitUrlArr() { // 银行开户许可证图片回调
      return this.authentication.permitUrl.split(',').filter(n => n) // 数组去空
    },
    vehicleOperationUrlArr() { // 车辆营运证图片回调
      return this.authentication.vehicleOperationUrl.split(',').filter(n => n) // 数组去空
    },
    roadTransportUrlArr() { // 道路运输许可证图片回调
      return this.authentication.roadTransportUrl.split(',').filter(n => n) // 数组去空
    },
    safeTransportUrlArr() { // 安全运输许可证图片回调
      return this.authentication.safeTransportUrl.split(',').filter(n => n) // 数组去空
    }

  },
  watch: {
    '$route'(to, from) { // 监听刷新页面
      if (to.name == 'QualificationsAuthen') {
        this.apilist()
      }
    }
  },
  // 初始化加载 所有资格认证数据
  created() {
    // 获取用户信息
    store.dispatch('user/getInfo')
    // 获取消息通知过来的数据
    if (this.$route.params.noticeId != undefined) {
      // console.log('消息通知过来的数据', 'id:' + this.$route.params.noticeId, 'type:' + this.$route.params.noticeMark)
    }
    (async() => {
      await this.getArea()
      await this.getBusinessDuration()
      await this.getTransportRange()
      await this.getTransportType()
      await this.getOwnedVehicle()
      await this.getInformatization()
      await this.getAuthenticationType()
      await this.getStorageType()
      await this.getTankType()
      await this.getAttestationStorageType()
      await this.getOwendStorageArea()
      await this.getElectronicWaybillManagement()
      await this.getCustomerEnquirySystem()
      this.apilist()
    })()
  },
  methods: {
    getLocalStorageUtil(name) {
      return new Promise((resolve, reject) => {
        if (dataBase.localStorageUtil.has(name)) {
          resolve(JSON.parse(dataBase.localStorageUtil.get(name)))
        } else {
          reject(name)
        }
      })
    },
    setLocalStorageUtil(name, result) {
      dataBase.localStorageUtil.set(name, JSON.stringify(result))
    },
    // 仓库位置点击事件处理
    expandChange() {
      setTimeout(function() {
        var alist = document.getElementsByClassName('el-radio__original')
        if (alist) {
          for (var idx = 0; idx < alist.length; idx++) {
            var mya = alist[idx]
            mya.style.cssText = 'width:160px;height:34px;z-index:1;top:-10px;cursor:inherit'
          }
        }
        console.log('执行了')
      }, 100)
    },
    // 详情位置回调
    handleSelect(item) {
      console.log(item)
    },
    // 地图定位查询
    querySearch(queryString, cb) {
      const addres = this.authentication.companyAddress
      if (addres == null || addres == '') {
        var isError = document.getElementsByClassName('companyAddress')
        this.authentication.detailsAddress = ''
        isError[0].querySelector('input').focus()
        cb([])
        this.$message({
          message: '请先选择公司地址!',
          offset: 100,
          type: 'warning'
        })
        // this.isErrorShow('请先选择公司地址!')
        return
      }
      if (queryString == null || queryString == '') {
        cb([])
        return
      }
      var results = []
      AMap.service(['AMap.PlaceSearch'], () => {
      // 构造地点查询类
        const placeSearch = new AMap.PlaceSearch({
          pageSize: 5, // 单页显示结果条数
          pageIndex: 1, // 页码
          // city: '济南', // 兴趣点城市
          city: addres[addres.length - 1],
          citylimit: true // 是否强制限制在设置的城市内搜索
          // map: map // 展现结果的地图实例
          // panel: 'panel', // 结果列表将在此容器中进行展示。
          // autoFitView: true // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
        })
        // 关键字查询
        placeSearch.search(queryString, (status, result) => {
          if (status == 'complete') {
            result.poiList.pois.forEach(element => {
              results.push({ 'title': element.name, 'value': element.address + element.name, 'address': element.name, 'location': element.location })
            })
            cb(results)
          } else {
            this.authentication.detailsAddress = ''
            cb(results)
            this.$message({
              message: '暂无数据!',
              offset: 100,
              type: 'warning'
            })
          }
        })
      })
    },
    // 详情地址错误提示
    isErrorShow(errName) {
      setTimeout(function() {
        var isDetailsError = document.getElementsByClassName('detailsAddress')
        var detaError = isDetailsError[0].querySelector('.el-form-item__error')
        if (!detaError) {
          var autocomplete = isDetailsError[0].querySelector('.el-form-item__content')
          var btn = document.createElement('div')
          var att = document.createAttribute('class')
          att.value = 'el-form-item__error'
          btn.setAttributeNode(att)
          var t = document.createTextNode(errName)
          btn.appendChild(t)
          autocomplete.appendChild(btn)
          // var t=document.createTextNode("CLICK ME");
        } else {
          detaError.innerHTML = errName
        }
      }, 100)
    },
    // 地址字典
    getArea() {
      this.getLocalStorageUtil('area').then((data) => {
        this.area = data
      }).catch(() => {
        getArea()
          .then(data => {
            this.area = data.result
            this.setLocalStorageUtil('area', data.result)
          })
          .catch(error => {
            console.error(error)
          })
      })
    },
    // 营业年限字典
    getBusinessDuration() {
      this.getLocalStorageUtil('businessDuration').then((businessDuration) => {
        if (businessDuration.length > 0) {
          businessDuration.forEach(res => {
            this.authenType.businessDuration.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('businessDuration').then(res => {
          const businessDuration = JSON.parse(res.result)
          this.setLocalStorageUtil('businessDuration', businessDuration)
          if (businessDuration.length > 0) {
            businessDuration.forEach(res => {
              this.authenType.businessDuration.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 运输范围字典
    getTransportRange() {
      this.getLocalStorageUtil('transportRange').then((transportRange) => {
        if (transportRange.length > 0) {
          transportRange.forEach(res => {
            this.authenType.transportRange.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('transportRange').then(res => {
          const transportRange = JSON.parse(res.result)
          this.setLocalStorageUtil('transportRange', transportRange)
          if (transportRange.length > 0) {
            transportRange.forEach(res => {
              this.authenType.transportRange.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 运输方式字典
    getTransportType() {
      this.getLocalStorageUtil('transportType').then((transportType) => {
        if (transportType.length > 0) {
          transportType.forEach(res => {
            this.authenType.transportType.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('transportType').then(res => {
          const transportType = JSON.parse(res.result)
          this.setLocalStorageUtil('transportType', transportType)
          if (transportType.length > 0) {
            transportType.forEach(res => {
              this.authenType.transportType.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 自有车辆字典
    getOwnedVehicle() {
      this.getLocalStorageUtil('ownedVehicle').then((ownedVehicle) => {
        if (ownedVehicle.length > 0) {
          ownedVehicle.forEach(res => {
            this.authenType.ownedVehicle.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('ownedVehicle').then(res => {
          const ownedVehicle = JSON.parse(res.result)
          this.setLocalStorageUtil('ownedVehicle', ownedVehicle)
          if (ownedVehicle.length > 0) {
            ownedVehicle.forEach(res => {
              this.authenType.ownedVehicle.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 信息化情况字典
    getInformatization() {
      this.getLocalStorageUtil('informatization').then((informatization) => {
        if (informatization.length > 0) {
          informatization.forEach(res => {
            this.authenType.informatization.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('informatization').then(res => {
          const informatization = JSON.parse(res.result)
          this.setLocalStorageUtil('informatization', informatization)
          if (informatization.length > 0) {
            informatization.forEach(res => {
              this.authenType.informatization.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 资质认证仓库类型字典
    getAuthenticationType() {
      this.getLocalStorageUtil('authenticationType').then((authenticationType) => {
        if (authenticationType.length > 0) {
          authenticationType.forEach(res => {
            this.authenType.authenticationType.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('authenticationType').then(res => {
          const authenticationType = JSON.parse(res.result)
          this.setLocalStorageUtil('authenticationType', authenticationType)
          if (authenticationType.length > 0) {
            authenticationType.forEach(res => {
              this.authenType.authenticationType.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 可存储类型字典
    getAttestationStorageType() {
      this.getLocalStorageUtil('attestationStorageType').then((attestationStorageType) => {
        if (attestationStorageType.length > 0) {
          attestationStorageType.forEach(res => {
            this.authenType.attestationStorageType.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('attestationStorageType').then(res => {
          const attestationStorageType = JSON.parse(res.result)
          this.setLocalStorageUtil('attestationStorageType', attestationStorageType)
          if (attestationStorageType.length > 0) {
            attestationStorageType.forEach(res => {
              this.authenType.attestationStorageType.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 储存类型字典
    getStorageType() {
      this.getLocalStorageUtil('storageType').then((storageType) => {
        if (storageType.length > 0) {
          storageType.forEach(res => {
            this.authenType.storageType.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('storageType').then(res => {
          const storageType = JSON.parse(res.result)
          this.setLocalStorageUtil('storageType', storageType)
          if (storageType.length > 0) {
            storageType.forEach(res => {
              this.authenType.storageType.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 罐区储存类型字典
    getTankType() {
      this.getLocalStorageUtil('tankType').then((tankType) => {
        if (tankType.length > 0) {
          tankType.forEach(res => {
            this.authenType.tankType.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('tankType').then(res => {
          const tankType = JSON.parse(res.result)
          this.setLocalStorageUtil('tankType', tankType)
          if (tankType.length > 0) {
            tankType.forEach(res => {
              this.authenType.tankType.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 自有仓面积字典
    getOwendStorageArea() {
      this.getLocalStorageUtil('owendStorageArea').then((owendStorageArea) => {
        if (owendStorageArea.length > 0) {
          owendStorageArea.forEach(res => {
            this.authenType.owendStorageArea.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('owendStorageArea').then(res => {
          const owendStorageArea = JSON.parse(res.result)
          this.setLocalStorageUtil('owendStorageArea', owendStorageArea)
          if (owendStorageArea.length > 0) {
            owendStorageArea.forEach(res => {
              this.authenType.owendStorageArea.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 电子运单管理字典
    getElectronicWaybillManagement() {
      this.getLocalStorageUtil('electronicWaybillManagement').then((electronicWaybillManagement) => {
        if (electronicWaybillManagement.length > 0) {
          electronicWaybillManagement.forEach(res => {
            this.authenType.electronicWaybillManagement.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('electronicWaybillManagement').then(res => {
          const electronicWaybillManagement = JSON.parse(res.result)
          this.setLocalStorageUtil('electronicWaybillManagement', electronicWaybillManagement)
          if (electronicWaybillManagement.length > 0) {
         electronicWaybillManagement = electronicWaybillManagement.sort()
            electronicWaybillManagement.forEach(res => {
              this.authenType.electronicWaybillManagement.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 客户查询系统字典
    getCustomerEnquirySystem() {
      this.getLocalStorageUtil('CustomerEnquirySystem').then((CustomerEnquirySystem) => {
        if (CustomerEnquirySystem.length > 0) {
          CustomerEnquirySystem.forEach(res => {
            this.authenType.CustomerEnquirySystem.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('CustomerEnquirySystem').then(res => {
          const CustomerEnquirySystem = JSON.parse(res.result)
          this.setLocalStorageUtil('CustomerEnquirySystem', CustomerEnquirySystem)
          if (CustomerEnquirySystem.length > 0) {
            CustomerEnquirySystem.forEach(res => {
              this.authenType.CustomerEnquirySystem.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 跳转员工管理頁面
    OpenStaff() {
      this.$router.push({ name: 'CompanyInfo' })
    },
    // 跳转申诉页面
    appealAchieve() {
      this.$router.push({
        name: 'Appeal',
        params: {
        }
      })
    },
    // 初始化头部信息
    failShow(item, index) {
      return `${index + 1}.${this.failContent[item - 1]}`
    },
    // 公司类型转换
    setCompanyShow() {
      if (this.userType != null) {
        this.authenticationFile = this.companyTypefile[this.userType]
        return this.companyTypeName[this.userType]
      } else {
        return ''
      }
    },
    // 储存权限控制
    typeSel(val) {
      this.authentication.storageType == ''
      if (val == null) {
        return false
      }
      if (val.length <= 0) {
        this.typeDisplay(true, true, true, true)
      } else if (val.length >= 2) {
        this.typeDisplay(false, false, false, false)
        // this.authentication.casingVolume = ''
        // this.authentication.tanksCount = ''
        // this.authentication.owendStorageArea = ''
      } else {
        if (val[0] == '1') {
          this.typeDisplay(true, true, false, false)
          this.authentication.casingVolume = ''
          this.authentication.tanksCount = ''
        }
        if (val[0] == '2') {
          this.typeDisplay(false, false, true, false)
          this.authentication.owendStorageArea = ''
        }
      }
    },
    // 储存类型权限内容控制
    typeDisplay(kqrj, cgsl, zy, yy) {
      this.kqrjDisabled = kqrj
      this.cgslDisabled = cgsl
      this.zyDisabled = zy
      this.yyDisabled = yy
    },
    // 数据发布
    modifiedAuthentication(rulesForm) {
      // 正则验证数据 是否为空 根据el from的唯一标识
      this.$refs[rulesForm].validate(valid => {
        if (valid) {
          const params = JSON.parse(JSON.stringify(this.authentication))
          if (params.companyLogo != null && Object.prototype.toString.call(params.companyLogo).indexOf('array') !== -1) {
            params.companyLogo = params.companyLogo.toString()
          }
          if (params.companyAddress != null && params.companyAddress.length > 0) {
            params.companyAddress = params.companyAddress.join('#')
          } else {
            params.companyAddress = null
          }
          if (params.transportMode != null && params.transportMode.length > 0) {
            params.transportMode = params.transportMode.join(',')
          } else {
            params.transportMode = null
          }
          if (params.warehouseType != null && params.warehouseType.length > 0) {
            params.warehouseType = params.warehouseType.join(',')
          } else {
            params.warehouseType = null
          }
          if (params.storageType != null && params.storageType.length > 0) {
            params.storageType = params.storageType.join(',')
          } else {
            params.storageType = null
          }
          if (params.returnReasons != null && params.returnReasons.length > 0) {
            params.returnReasons = params.returnReasons.join(',')
          } else {
            params.returnReasons = null
          }
          params.authStatus = '1'

          console.log("this.authentication.id:"+this.authentication.id)
          if (this.authentication.id != null) {
            this.post_flag = true
            editInfo(params).then((result) => {
              // 成功提示
              this.$message({
                showClose: true,
                message: '恭喜您，资质认证资料已提交!',
                type: 'success'
              })
              this.apilist()
              this.reload()
            }).catch((err) => {
              console.log(err)
              this.post_flag = false
            })
          } else {
            this.post_flag = true
            createInfo(params).then((result) => {
              // 成功提示
              this.$message({
                showClose: true,
                message: '恭喜您，资质认证资料已提交!',
                type: 'success'
              })
              this.apilist()
              this.reload()
            }).catch((err) => {
              console.log(err)
              this.post_flag = false
            })
          }
        } else {
          // 失败返回数据
          setTimeout(() => {
            var isError = document.getElementsByClassName('is-error')
            if (isError[0].querySelector('input').type == 'file') {
              isError[0].querySelector('input').style.display = 'block'
              isError[0].querySelector('input').focus()
              isError[0].querySelector('input').style.display = 'none'
            } else {
              isError[0].querySelector('input').focus()
            }
          }, 1)
          return false
        }
      })
    },
    // 根据Uid查询当前认证状态
    apilist() {
      this.loading = true
      getUserInfo({ userId: null }).then(res => {
        console.log(res)
        // 打印输出
        if (res.result != null) {
          if (res.result.authStatus == '1') {
            this.renzhengCrad(false, false, true, false, false)
          } else if (res.result.authStatus == '2') {
            this.renzhengCrad(false, false, false, true, false)
          } else if (res.result.authStatus == '3') {
            this.renzhengCrad(false, false, false, false, true)
          } else if (res.result.authStatus == '4') {
            this.$router.push({
              name: 'Appeal',
              params: {
              }
            })
          } else if (res.result.authStatus == '5') {
            this.renzhengCrad(true, true, false, false, false)
          } else {
            this.renzhengCrad(false, false, true, false, false)
          }
          this.authentication = res.result
          this.authentication.warehouseType = !res.result.warehouseType ? [] : res.result.warehouseType.split(',')
          this.authentication.storageType = !res.result.storageType ? [] : res.result.storageType.split(',')
          this.authentication.transportMode = !res.result.transportMode ? [] : res.result.transportMode.split(',')
          this.authentication.returnReasons = !res.result.returnReasons ? [] : res.result.returnReasons.split(',')
          this.authentication.companyAddress = !res.result.companyAddress ? [] : res.result.companyAddress.split('#')
          this.authentication.companyLogo = this.authentication.companyLogo ? this.authentication.companyLogo : ''
          this.typeSel(this.authentication.warehouseType)
          // console.log(res.result)
        } else {
          this.renzhengCrad(true, true, false, false, false)
        }
        if (res.user != null) {
          this.user = res.user
        }
        return
      }).catch(() => {
        this.renzhengCrad(true, true, false, false, false)
      }).finally(() => {
        this.loading = false
        this.post_flag = false
      })
    },
    // 页面展示权限
    renzhengCrad(renzhen, submit, tj, success, fail) {
      this.renzhenCard = renzhen
      this.submitCard = submit
      this.tjCard = tj
      this.SuccessCard = success
      this.failCard = fail
    }
  }
}
</script>
<style scoped lang='scss'>
  @import "@/styles/standardColor.scss";

  .logText{
    font-size: 14px;
    font-weight: 600;
    line-height: 27px;
    color: #909399;
    padding-top: 0.3rem;
  }
  .title{
    padding-top: 20px;
    span{
      color: #be2316;
      border-bottom: 1px solid;
      padding: 1rem;
      cursor: pointer;
    }
  }
  .tjClas{
    padding:3rem;text-align: center;
    .box-card span{
      &:nth-child(1){
        width:100%;
        display: block;
        font-size: -webkit-xxx-large;
        font-family: cursive;
      }
      &:nth-child(2){
        display: block;
        width:100%;
        margin-top:3rem;
      }
    }
  }
  .SuccessClas{
    padding:3rem;
    text-align: center;
    .box-card{
      span{
        &:nth-child(1){
          width:100%;
          display: block;
          font-size: -webkit-xxx-large;
          font-family: cursive;
        }
        &:nth-child(2){
          width:100%;
          display: block;
          font-size: -webkit-xxx-large;
          font-family: cursive;
          margin-top:1rem;
        }
      }
      .suCentClas{
        margin-top:1rem;
        span{
          width:100%;
          margin-top:3rem;
          font-size: unset;
          font-family: unset;
        }
      }
    }
  }
  .failClas{
    padding:3rem;
    text-align: center;
    .box-card span{
      &:nth-child(1){
        width:100%;
        display: block;
        font-size: -webkit-xxx-large;
        font-family: cursive;
      }
      &:nth-child(2){
        display: block;
        width:100%;
        font-size: x-large;
        font-family: cursive;
        margin-top: 1rem;
        text-align: left;
      }
      &:nth-of-type(3){
        display: block;
        width: 100%;
        text-align: center;
        margin-top: 1rem;
      }
    }
  }

  /deep/a{
    text-decoration: none;
  }
   // 上传图片js
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  // 前面都是上传
  .intenal-box {
    width: 100%;
    height: 100%;
    padding: 50px 0px;
  }

    .upload-icon{
    margin: auto auto;
    width: 100%;
    line-height: 24px;
  }
  .upload-info-text{
    margin: auto auto;
    width: 100%;
    line-height: 50px;
  }

    /deep/ .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before  {
    content: '*';
    color: #be2316;
    font-size: 16px;
    margin-right: 4px;
  }
  input__inner {
    background-color: white;
    border-radius: 0px;
    border: 0;
    border-bottom: 1px solid gainsboro;
  }
  /deep/.el-input input{
    border-radius:0px;
  }
  /deep/.checkboxSty .el-input .el-input__inner , /deep/.el-textarea .el-textarea__inner{
    border-radius:0px;
  }
  /deep/.el-form-item {
    margin-bottom: 20px;
  }
  /deep/.checkboxSty{
    width:100%;
  }
  /deep/.sfSty{
    color:#409EFF
  }
  /deep/.sfSty:hover{
    color: #8c939d
  }
  /deep/.el-card .el-card__body{
    // display: grid;
    padding: 4rem;
  }

  /deep/.el-upload-list--picture-card {
    display: block !important;
  }

  /deep/.companyLogoItem .companyLogo .el-upload{
    width: 4rem;
    height: 4rem;
    line-height: 73px;
    i{
        margin-right: 0px;
    }
  }

  /deep/.companyLogoItem .el-upload-list--picture-card .el-upload-list__item{
    width: 4rem;
    height: 4rem;
  }
  .el-button-ml{
    margin-left: 35%;
    width: 35%;
    height: 40px;
    margin-top: 50px;
    font-size: 18px;
    background-color: #BE2316;
    margin-bottom: 10%
  }
  .menu-head {
    display: flex;
    margin: 1rem;
    padding-bottom: 1rem;
    border-style: dashed;
    border-width: 0 0 1px 0;
    border-color: #f1f1f1;
    .head-color {
      width: 5px;
      height: 18px;
      background-color: #be2316;
      border-radius: 5px;
      margin-right: 1rem;
    }
    font-size: 18px;
    font-weight: bold;
  }
  .main-wrap{
    width: 100%;
    background-color: white;
    margin-top: -15px;
  }
</style>
